function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BTC_svg__clip0_1_151)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 15,
  cy: 14.722,
  rx: 15,
  ry: 14.167,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 29.244c-8.287 0-15-6.444-15-14.4S6.713.444 15 .444c8.288 0 15 6.444 15 14.4s-6.712 14.4-15 14.4zm6.738-16.176c.3-1.884-1.2-2.904-3.25-3.576l.662-2.556-1.625-.384-.65 2.484c-.425-.108-.863-.192-1.3-.288l.65-2.508-1.625-.384-.637 2.544c-.35-.084-.7-.156-1.038-.24v-.012l-2.238-.54-.437 1.668s1.2.264 1.175.276c.662.156.775.576.75.9l-.75 2.916c.05.012.1.024.175.048l-.175-.036-1.063 4.08c-.075.192-.287.48-.75.372.013.024-1.175-.288-1.175-.288l-.8 1.776 2.113.504c.387.096.775.192 1.15.288l-.675 2.58 1.625.384.662-2.556c.438.12.875.216 1.288.324l-.663 2.544 1.625.384.675-2.58c2.763.504 4.838.3 5.713-2.1.7-1.932-.037-3.048-1.487-3.768 1.062-.204 1.862-.876 2.075-2.256zm-3.7 4.98c-.5 1.932-3.888.888-4.988.624l.887-3.42c1.1.264 4.626.78 4.1 2.796zm.5-5.004c-.463 1.752-3.276.864-4.188.648l.813-3.108c.9.216 3.85.624 3.375 2.46z",
  fill: "#F7931A"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BTC_svg__clip0_1_151"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "acc0681f34b4721906fd9da143ae573e.svg";
export { SvgBtc as ReactComponent };